const TRACKING_NAMESPACE = 'tracking';

export { TRACKING_NAMESPACE };
export default TRACKING_NAMESPACE;
